import { Component, HostListener, Input } from '@angular/core';
import { ButtonComponent } from '@usitsdasdesign/dds-ng/button';
import { ModalService } from '@usitsdasdesign/dds-ng/modal';
import { UploaderOptions, UploadFile } from '@usitsdasdesign/dds-ng/uploader';
import { Column, LabelPosition } from '@usitsdasdesign/dds-ng/shared';
import { ProgressOptions } from '@usitsdasdesign/dds-ng/progress';
import {
  SelectItemOptions,
  SelectOptions,
} from '@usitsdasdesign/dds-ng/select';
import { TextareaOptions } from '@usitsdasdesign/dds-ng/textarea';
import { DocumentService } from '../../../../../../http/document/document.service';
import { ProgressIndicatorService } from '../../../../../../common/services/progress-indicator.service';
import { CommonHelperService } from '../../../../../../common/services/common-helper.service';
import { NotifyPopupComponent } from '../../../../../../common/notify-popup/notify-popup.component';
import { SubmissionService } from '../../../../../../http/intake/submission.service';
import { Subject, takeUntil } from 'rxjs';
import { IntakeConstant } from '../../../../../constants/intake.constant';
import { PermissionsObj } from '../../../../../../common/models/common-models';
import { HttpErrorResponse } from '@angular/common/http';
import { IntakeDocumentTableModel } from '../../../../../../common/models/intake-document-table.model';
import {
  INTERNAL_RM_REVIEWED_DOC_STATUS_ALLOWED_ROLES,
  updateDocStatusDropdown,
} from '../../document-settings';
import {
  IntakeDocumentStatusIdMapper,
  DocumentStatus,
} from '../../../../../constants/document-status.enum';

@Component({
  selector: 'app-intake-document-upload',
  templateUrl: './intake-document-upload.component.html',
  styleUrl: './intake-document-upload.component.less',
})
export class IntakeDocumentUploadComponents {
  @Input() permissionObj: PermissionsObj = {} as PermissionsObj;
  @Input() rmReviewedGuidanceNoteHeader: string = IntakeConstant.EMPTY_SPACE;
  @Input() rmReviewedGuidanceNoteBody: string = IntakeConstant.EMPTY_SPACE;
  @Input() selfReviewEligibilityStatus: string | undefined =
    IntakeConstant.EMPTY_SPACE;
  @Input() optOutOfSelfReview: string | null | undefined =
    IntakeConstant.EMPTY_SPACE;
  @Input() documentTypeOptions: SelectItemOptions[] = [];
  @Input() set setDocumentStatusOptions(value: SelectItemOptions[]) {
    this.documentStatusOptions = value;
    this.allStatusAvailable = value;
  }

  constructor(
    private readonly intakeDetailService: SubmissionService,
    private readonly docService: DocumentService,
    private readonly modalService: ModalService,
    private readonly progressIndicator: ProgressIndicatorService,
    private readonly commonHelperService: CommonHelperService
  ) {}

  _EMPTY: string = IntakeConstant.EMPTY_SPACE;
  #unsubscriber$: Subject<void> = new Subject<void>();
  displayStyle: any = 'none';
  fileName: any = this._EMPTY;
  @Input() public documentInitiatedDetails: any = {};
  @Input() documentTableDataCurrently: IntakeDocumentTableModel[] = [];
  filePath: any = this._EMPTY;
  uploadFileSourceList: any = [];
  maxFileLength: any = 5;
  notifyReason: any = this._EMPTY;
  uploadRequestList: any = [];
  maxFileSizeAllowed: any = 50 * 1024 * 1024; // 50 MB in bytes
  maxFileSizeAllowedUpto: any = 100 * 1024 * 1024; // 100 MB in bytes
  isFileSize100MBExceed: boolean = false;
  validFileExtensions: any =
    'doc,docx,msg,pptx,pdf,ppt,xls,xlsb,xlsx,xlsm,jpg,jpeg,png,zip'; //Valid File Extensions
  fileSourceList: any = [];
  removeUploadedDocumentFromList: any = [];
  fileUploadPercentage: any = this._EMPTY;
  isEncrypted: boolean = true;
  isUploadingInProgress: boolean = false;
  isFileUploaded: boolean = false;
  isDocumentExists: boolean = false;
  documentUploadData: any = [];
  documentAllSectionsMetaData: any = [];
  documentUploadInProgressData: any = [];
  @Input() isFooter: boolean = false;
  @Input() size: string = this._EMPTY;
  @Input() isInverse: boolean = false;
  isEditing: boolean = false;
  otherTypeSelected: number = IntakeConstant.OTHER_STATUS;
  InternalRmReviewedDocStatusAllowedRoles: string[] =
    INTERNAL_RM_REVIEWED_DOC_STATUS_ALLOWED_ROLES;
  showRMReviewedGuidanceNote: boolean = false;
  documentStatusOptions: SelectItemOptions[] = [];
  allStatusAvailable: SelectItemOptions[] = [];

  uploadAreaOptions: UploaderOptions = {
    heading: this._EMPTY,
    dragAndDropText: 'Drag and drop file(s)',
    description:
      'All common file types are supported including: docx, pptx, pdf, .zip, etc. Max size of 50MB per file',
    isDragAndDrop: true,
    isMultiple: true,
    acceptFormats: this._EMPTY,
    acceptExtensions: this._EMPTY,
    restrictedFormats: this._EMPTY,
    restrictedExtensions: this._EMPTY,
    exceptSymbols: this._EMPTY,
    btnLabel: 'Select file(s)',
    chooseFileBtnKind: 'primary',
    isDownloadable: false,
    allowFilesWithoutType: false,
    disabled: false,
    isInverse: false,
  };
  textFileOptions: TextareaOptions = {
    placeholder: this._EMPTY,
    minHeight: 100,
    maxLength: 400,
    maxLengthPosition: 'bottom-right',
    size: IntakeConstant.UI_ELEMENT_SIZE,
  };
  textareaOptions: TextareaOptions = {
    placeholder: 'Enter Comment',
    minHeight: 100,
    maxLength: 400,
    maxLengthPosition: 'bottom-right',
    size: IntakeConstant.UI_ELEMENT_SIZE,
  };
  selectDocumentTypeOptions: SelectOptions = {
    label: this._EMPTY,
    labelPosition: LabelPosition.external,
    description: this._EMPTY,
    placeholder: 'Select type',
    size: IntakeConstant.UI_ELEMENT_SIZE,
    disabled: false,
    isResponsive: true,
    isRequired: true,
    isInverse: false,
    customClass: this._EMPTY,
    stickerWidth: 0,
    stickerShift: 0,
    stickerMaxHeight: this._EMPTY,
    stickerIsDisabled: false,
    stickerPosition: 'bottom-left',
    stickerIndent: 0,
    stickerCustomClass: this._EMPTY,
    stickerIsDynamic: true,
  };

  selectOptionsStatus: SelectOptions = {
    label: this._EMPTY,
    labelPosition: LabelPosition.external,
    description: this._EMPTY,
    placeholder: 'Select status',
    size: IntakeConstant.UI_ELEMENT_SIZE,
    disabled: false,
    isResponsive: true,
    isRequired: true,
    isInverse: false,
    customClass: this._EMPTY,
    stickerWidth: 0,
    stickerShift: 0,
    stickerMaxHeight: this._EMPTY,
    stickerIsDisabled: false,
    stickerPosition: 'bottom-left',
    stickerIndent: 0,
    stickerCustomClass: this._EMPTY,
    stickerIsDynamic: true,
  };
  options: ProgressOptions = {
    size: IntakeConstant.UI_ELEMENT_SIZE,
    theme: 'green',
    isInverse: false,
    label: this._EMPTY,
    description: this._EMPTY,
    isVertical: false,
  };
  public DocumentColumns: Column[] = [
    { name: 'Title', header: 'Title', dataType: 'string' },
    { name: 'Document type', header: 'Document type', dataType: 'string' },
    { name: 'Status', header: 'Status', dataType: 'string' },
    {
      name: 'Comment(optional)',
      header: 'Comment (optional)',
      dataType: 'string',
    },
  ];

  ngOnInit(): void {
    this.filePath = this.commonHelperService.getDocumentFolderPath(
      this.documentInitiatedDetails.moduleName
    );

    this.uploadedItems(this.documentInitiatedDetails.file);
  }

  onDocTypeChange(item: any): void {
    const { statusOptions, selectedDocStatus } = updateDocStatusDropdown(
      this.allStatusAvailable,
      this.documentInitiatedDetails.submissionTypeCode,
      this.documentInitiatedDetails.submissionStatus,
      item.documentTypeId,
      item.documentStatusId
    );

    item.documentStatusOptions = statusOptions;
    if (selectedDocStatus !== null) {
      item.documentStatusId = selectedDocStatus;
    }
  }

  onDocStatusChange(statusId: number): void {
    const rmReviewdId = IntakeDocumentStatusIdMapper.get(
      DocumentStatus.RMReviewed
    );
    statusId === rmReviewdId
      ? (this.showRMReviewedGuidanceNote = true)
      : (this.showRMReviewedGuidanceNote = false);
  }

  removeDocument(row: any): void {
    const index = this.documentUploadData.indexOf(row);
    if (index === -1) {
      return;
    }
    this.documentUploadData.splice(index, 1);
    this.fileSourceList = this.fileSourceList.filter(
      (element: any, index: any) =>
        this.removeUploadedDocumentFromList.indexOf(element.fileName) === -1
    );
    this.loadFileSourceData(this.fileSourceList);
  }

  async onSave(): Promise<void> {
    try {
      this.progressIndicator.show();
      await this.UploadFiletoS3();
      await this.saveDocumentMetaData();
      this.progressIndicator.hide();
    } catch (error) {
      this.progressIndicator.hide();
      console.error(error);
    }
    this.closeModal();
  }

  async saveDocumentMetaData(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.intakeDetailService
        .postDocumentSave(this.documentUploadData)
        .pipe(takeUntil(this.#unsubscriber$))
        .subscribe({
          next: (response: any) => {
            resolve();
          },
          error: (err: HttpErrorResponse) => {
            console.error('An error occurred during metadata save:', err);
            reject(err);
          },
        });
    });
  }

  validateDocumentAlreadyExists(title: boolean): boolean | string {
    let documentTitle = this._EMPTY;
    this.documentTableDataCurrently.forEach((element: any) => {
      this.documentUploadData.forEach((element1: any) => {
        if (element.documentTitle === element1.documentTitle) {
          documentTitle = element.documentTitle;
        }
      });
    });
    return title ? documentTitle : Boolean(documentTitle);
  }

  isSaveButtonDisabled(): boolean {
    if (this.documentUploadData.length === 0) {
      return false;
    }
    let tempData = this.documentUploadData.some(
      (obj: any) =>
        obj.documentTitle.length == 0 ||
        obj.documentTypeId.toString() == 0 ||
        obj.documentStatusId.toString() == 0
    );

    let optionalSelected = this.documentUploadData.some((obj: any) => {
      if (
        obj.documentTypeId === this.otherTypeSelected &&
        obj.comments.length === 0
      ) {
        return true;
      }
      return false;
    });
    return tempData ||
      optionalSelected ||
      Boolean(this.validateDocumentAlreadyExists(false))
      ? false
      : true;
  }

  loadFileSourceList(): void {
    this.uploadFileSourceList = [];
    this.documentUploadInProgressData = [];
    this.uploadRequestList = [];
    this.fileSourceList.forEach((element: any) => {
      this.uploadFileSourceList.push({ fileSource: element.file });
      this.documentUploadInProgressData.push({ fileName: element.file.name });
      let uploadRequest = {
        FileFolderPath: this.filePath,
        DocumentName: element.file.name,
      };

      this.uploadRequestList.push(uploadRequest);
      this.documentUploadData.push({
        submissionId: this.documentInitiatedDetails.submissionId,
        documentTypeId: 0,
        documentStatusId: 0,
        submissionDocumentTypeId: 1,
        documentTitle: element.file.name,
        documentUrl: this._EMPTY,
        comments: this._EMPTY,
        documentStatusOptions: [...this.documentStatusOptions],
      });
    });
    this.updateProgressBar('PresignedURLUpdated');
  }

  UploadDraggedAndSelectedDocument(): void {
    this.updateProgressBar('Validation');
    this.loadFileSourceList();
    this.updateProgressBar('uploaded');
  }

  updateProgressBar(event: any): void {
    if (event == 'Validation') {
      this.fileUploadPercentage = '50';
    } else if (event == 'PresignedURL') {
      this.fileUploadPercentage = '75';
    } else if (event == 'PresignedURLUpdated') {
      this.fileUploadPercentage = '95';
    } else if (event == 'uploaded') {
      this.fileUploadPercentage = '100';
    }
  }

  async UploadFiletoS3(): Promise<void> {
    const uploadPromises = this.uploadFileSourceList.map(
      (fileSource: any, index: number) => {
        return new Promise<void>((resolve, reject) => {
          this.docService
            .getUploadUrlForDCRMValidation(fileSource.fileSource.name)
            .subscribe({
              next: (presignedUrlData: any) => {
                this.docService
                  .uploadFileToS3UsingPresignedUrl(
                    presignedUrlData.resultData,
                    fileSource.fileSource
                  )
                  .subscribe(
                    () => {
                      this.docService
                        .uploadDocument(
                          fileSource.fileSource.name,
                          presignedUrlData.resultData.documentKey,
                          this.documentInitiatedDetails.moduleName
                        )
                        .subscribe({
                          next: (result: any) => {
                            this.updateProgressBar('PresignedURLUpdated');
                            if (this.documentUploadData[index]) {
                              this.documentUploadData[index].attachmentId =
                                result.attachmentID;
                            }
                            resolve();
                          },
                          error: (err: HttpErrorResponse) => {
                            console.error('Error uploading file:', err);
                            reject(err);
                          },
                        });
                    },
                    (error) => {
                      console.error('Error uploading file:', error);
                      this.progressIndicator.hide();
                    }
                  );
              },
              error: (error: HttpErrorResponse) => {
                console.error('Error getting presigned URL:', error);
                this.progressIndicator.hide();
              },
            });
        });
      }
    );

    await Promise.all(uploadPromises);
  }

  enableDisableUIDocumentDetails(): void {
    this.isUploadingInProgress = false;
    this.isFileUploaded = false;
    if (this.documentUploadData.length > 0) {
      this.isFileUploaded = true;
    }
    if (this.fileSourceList.length > 0) {
      this.isUploadingInProgress = true;
    }
  }

  applyBodyOverflow(): void {
    document.body.style.overflow = 'auto';
  }

  openModal(): void {
    this.modalService.open(IntakeDocumentUploadComponents);
  }

  closeModal(): void {
    this.applyBodyOverflow();
    this.uploadFileSourceList = [];
    this.documentUploadInProgressData = [];
    this.uploadRequestList = [];
    this.documentInitiatedDetails.file = [];
    this.documentUploadData = [];

    this.modalService.close(this.documentAllSectionsMetaData);
  }

  isFileExtensionValid(): boolean {
    let isFileExtensionValid = true;
    this.fileSourceList.forEach((element: any) => {
      if (
        !this.validFileExtensions
          .toString()
          .toLowerCase()
          .includes(element.fileExtenstion.toString().toLowerCase())
      ) {
        isFileExtensionValid = false;
      }
    });
    return isFileExtensionValid;
  }

  isFileSizeExceed(): boolean {
    let isFileSizeExceed = false;
    this.isFileSize100MBExceed = false;
    this.fileSourceList.forEach((element: any) => {
      if (
        element.file.size > this.maxFileSizeAllowed &&
        element.file.size <= this.maxFileSizeAllowedUpto
      ) {
        isFileSizeExceed = true;
      } else if (element.file.size > this.maxFileSizeAllowedUpto) {
        this.isFileSize100MBExceed = true;
      }
    });
    return isFileSizeExceed;
  }

  isMaxFileSelectionExceed(): boolean {
    let isMaxFileSelectionExceed = false;
    let selectedFileCount =
      this.fileSourceList.length + this.documentUploadData.length;
    if (selectedFileCount > this.maxFileLength) {
      isMaxFileSelectionExceed = true;
    }
    return isMaxFileSelectionExceed;
  }

  removeBodyOverflow(): void {
    document.body.style.overflow = 'hidden';
  }

  showMsg(modalBtn?: ButtonComponent) {
    this.removeBodyOverflow();
    const modalRef = this.modalService.open(NotifyPopupComponent, {
      isFooter: true,
      size: 'md',
      isInverse: false,
      notifyReason: this.notifyReason,
    });

    modalRef.onClosed().subscribe(() => {
      if (modalBtn) {
        modalBtn.focus();
      }
    });
  }

  uploadedItems(filesList: UploadFile[]): void {
    if (filesList.length > 0) {
      this.removePreviousUploadDocument(filesList);
      if (this.fileSourceList.length > 0) {
        if (this.isFileSizeExceed()) {
          this.notifyReason = 'inValidFileSize';
          this.showMsg();
          this.IsDocumentProtected();
        } else if (this.isMaxFileSelectionExceed()) {
          this.notifyReason = 'inValidFileSelection';
          this.showMsg();
        } else if (!this.isFileExtensionValid()) {
          this.notifyReason = 'inValidFileType';
          this.showMsg();
        } else {
          this.IsDocumentProtected();
        }
      }
    }
  }

  IsDocumentProtected(): void {
    this.UploadDraggedAndSelectedDocument();
  }

  loadFileSourceData(fileSource: any): void {
    fileSource.forEach((element: any) => {
      this.removeUploadedDocumentFromList.push(element.fileName);
    });
  }

  removePreviousUploadDocument(filesListSource: any): void {
    if (this.removeUploadedDocumentFromList.length == 0) {
      this.loadFileSourceData(filesListSource);
      this.fileSourceList = filesListSource;
    } else {
      this.fileSourceList = filesListSource.filter(
        (element: any, index: any) =>
          this.removeUploadedDocumentFromList.indexOf(element.fileName) === -1
      );
      this.loadFileSourceData(this.fileSourceList);
    }
  }

  onFileNameEdit(row: any): void {
    row.isFileNameInEditMode = true;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    this.documentUploadData.forEach(
      (obj: { isFileNameInEditMode: boolean }) => {
        if (!target.closest('.editing')) {
          if (this.isEditing) {
            obj.isFileNameInEditMode = false;
            this.isEditing = false;
          } else {
            this.isEditing = true;
          }
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.#unsubscriber$.next();
    this.#unsubscriber$.complete();
  }
}
